// -----------------------------------------------------------------------------
// Scripts for smooth scrolling
// -----------------------------------------------------------------------------

$(function () {
  $('a[href^="#"]').on('click', function (event) {
    const target = $(this.getAttribute('href'));
  
    if (target.length) {
      event.preventDefault();
      
      $('html, body').stop().animate({
        scrollTop: target.offset().top
      }, 300, 'linear');
    }
  });
});